{#if badge}
  <span class="badge">
    {badge}
  </span>
{/if}
{>button}


{#snippet content}
  {#if animated}
    {> animated}
  {else}
    {#if not iconAfter}
      {> icon}
    {/if}
    {#if not iconOnly}
      <span class="text">
        {> slot}
      </span>
    {/if}
    {#if iconAfter}
      {> icon}
    {/if}
  {/if}
{/snippet}

{#snippet button}
  {#if href}
    <a class="{uiClasses}button" href="{href}" part="button">
      {> content}
    </a>
  {else}
    <div class="{uiClasses}button" tabindex="0" part="button">
      {> content}
    </div>
  {/if}
{/snippet}

{#snippet icon}
  {#if icon}
    <ui-icon icon={icon} class="icon" part="icon"></ui-icon>
  {/if}
  {>slot icon}
{/snippet}

{#snippet badge}
  {#if badge}
    <span class="badge" part="badge">{badge}</span>
  {/if}
  {>slot badge}
{/snippet}

{#snippet animated}
  <span class="hidden content">
    {>slot hidden}
  </span>
  <span class="visible content">
    {>slot visible}
  </span>
{/snippet}
